// extracted by mini-css-extract-plugin
export default {"title":"AboutPanel_title__AMPHp","text":"AboutPanel_text__oB4nW"};